import { useUpcomingTransactions } from "./useUpcomingTransactions";

export const useNextTransfer = () => {
  const { data: queryData, loading, error, ...rest } = useUpcomingTransactions();

  const data = queryData?.[0];

  return { data, loading, error, ...rest };
};
